import React, { useState } from 'react';
import { toast } from 'sonner';
import { Drawer, F, field, primary, useApi } from './ui';

const BLANK = { name: '', mobile: '', contact_person: '', email: '', active: true, gstin: '', gstin_expiry: '', pan: '', building: '', street: '',
  city: '', state: '', pincode: '', bank_name: '', bank_branch: '', ifsc: '', account_no: '', credit_limit: 0, credit_days: 0, discount_pct: 0, remarks: '', item_ids: [] };
const SECTIONS = [
  ['Basics', [['name', 'Vendor name *'], ['mobile', 'Mobile * (+91)'], ['contact_person', 'Contact person'], ['email', 'Email']]],
  ['Tax', [['gstin', 'GSTIN'], ['gstin_expiry', 'GSTIN expiry', 'date'], ['pan', 'PAN']]],
  ['Address', [['building', 'Building'], ['street', 'Street'], ['city', 'City'], ['state', 'State'], ['pincode', 'Pincode']]],
  ['Bank', [['bank_name', 'Bank name'], ['bank_branch', 'Branch'], ['ifsc', 'IFSC'], ['account_no', 'Account no.']]],
  ['Terms', [['credit_limit', 'Credit limit ₹', 'number'], ['credit_days', 'Credit days', 'number'], ['discount_pct', 'Default discount %', 'number'], ['remarks', 'Remarks']]],
];

export const VendorDrawer = ({ vendor, items, onClose, onSaved }) => {
  const { call } = useApi();
  const [v, setV] = useState({ ...BLANK, ...(vendor || {}) });
  const [busy, setBusy] = useState(false);
  const set = (k, val) => setV((s) => ({ ...s, [k]: val }));
  const save = async () => {
    setBusy(true);
    try {
      const body = { ...v, credit_limit: Number(v.credit_limit) || 0, credit_days: Number(v.credit_days) || 0, discount_pct: Number(v.discount_pct) || 0 };
      const out = vendor?.id ? await call('put', `/purchasing/vendors/${vendor.id}`, body) : await call('post', '/purchasing/vendors', body);
      toast.success('Vendor saved');
      onSaved(out);
    } catch { /* toasted */ } finally { setBusy(false); }
  };
  const toggleItem = (id) => set('item_ids', v.item_ids.includes(id) ? v.item_ids.filter((x) => x !== id) : [...v.item_ids, id]);
  return (
    <Drawer title={vendor?.id ? 'Edit vendor' : 'New vendor'} onClose={onClose} testid="vendor-drawer"
      footer={<button className={primary} disabled={busy || !v.name || !v.mobile} onClick={save} data-testid="vendor-save">Save vendor</button>}>
      {SECTIONS.map(([title, fields]) => (
        <section key={title}>
          <h3 className="mb-2 text-sm font-bold text-slate-800">{title}</h3>
          <div className="grid gap-3 sm:grid-cols-2">
            {fields.map(([k, label, type]) => (
              <F key={k} label={label}>
                <input type={type || 'text'} value={v[k] ?? ''} onChange={(e) => set(k, k === 'gstin' || k === 'ifsc' ? e.target.value.toUpperCase() : e.target.value)}
                  className={field} data-testid={`vendor-${k}`} />
              </F>
            ))}
          </div>
        </section>
      ))}
      <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={v.active} onChange={(e) => set('active', e.target.checked)} data-testid="vendor-active" /> Active</label>
      <section>
        <h3 className="mb-2 text-sm font-bold text-slate-800">Parts supplied</h3>
        <div className="flex max-h-40 flex-wrap gap-1.5 overflow-y-auto" data-testid="vendor-parts">
          {items.map((it) => (
            <button key={it.id} type="button" onClick={() => toggleItem(it.id)}
              className={`rounded-full border px-2.5 py-1 text-xs ${v.item_ids.includes(it.id) ? 'border-teal-500 bg-teal-50 text-teal-800' : 'border-slate-200 text-slate-600'}`}>{it.name}</button>
          ))}
        </div>
      </section>
    </Drawer>
  );
};
